export const PAST_PERIOD_OPTIONS = [
  { label: "Última semana", value: "lastWeek" },
  { label: "Últimos 15 días", value: "last2Weeks" },
  { label: "Último mes", value: "lastMonth" },
  { label: "Últimos tres meses", value: "last3Months" },
  { label: "Últimos seis meses", value: "last6Months" },
  { label: "Último año", value: "lastYear" },
];

export const FUTURE_PERIOD_OPTIONS = [
  { label: "Próxima semana", value: "nextWeek" },
  { label: "Próximos 15 días", value: "next2Weeks" },
  { label: "Próximo mes", value: "nextMonth" },
  { label: "Próximos tres meses", value: "next3Months" },
  { label: "Próximos seis meses", value: "next6Months" },
  { label: "Próximo año", value: "nextYear" },
];

export const TIME_FILTER_OPTIONS = {
  past: {
    defaultPeriod: "Última semana",
    selectOptions: PAST_PERIOD_OPTIONS,
  },
  future: {
    defaultPeriod: "Próxima semana",
    selectOptions: FUTURE_PERIOD_OPTIONS,
  },
  npsPeriods: {
    defaultPeriod: "Últimos tres meses",
    selectOptions: [
      ...PAST_PERIOD_OPTIONS,
      { label: "Últimos 3 años", value: "last3Years" }
    ],
  }
};
const NPS_FILLED = "npsFilled";
const NPS_SCORE = "npsScore";

export const NPS_TYPES = [NPS_FILLED, NPS_SCORE];

const options = {
  ticks: {
    precision: 0,
  },
  scales: {
    y: {
      beginAtZero: true,
    },
    x: {
      grid: {
        offset: true,
        display: false,
      },
    },
  },
  responsive: true,
  maintainAspectRatio: false,
  width: 400,
  height: 300,
  plugins: {
    legend: {
      display: false,
    },
  },
};

const npsOptions = {
  ...options,
  scales: {
    y: {
      beginAtZero: false,
      min: -100,
      max: 100,
      steps: 10,
    },
    x: {
      grid: {
        offset: true,
        display: false,
      },
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        title: (items) => items[0].label,
        label: (context) => {
          const { y, promoters = 0, passives = 0, detractors = 0, totalChecked = 0 } = context.raw;

          return [
            `NPS: ${y}`,
            `Total encuestados: ${totalChecked}`,
            `Promotores: ${promoters}`,
            `Pasivos: ${passives}`,
            `Detractores: ${detractors}`,
          ];
        },
      },
    },
  },
};

export const getGraphOptions = (type) => {
  if (type === NPS_SCORE) return { ...npsOptions };
  return { ...options };
};

const getNpsColor = (value) => {
  if (value < 0) return "#E16E5F";
  return "#6BBBC5";
};

export const graphDataConfig = {
  labels: [],
  datasets: [
    {
      borderRadius: 2,
      borderWidth: 1,
      data: [],
      barThickness: 15,
      borderColor: (ctx) => {
        const raw = ctx.raw;
        if (!raw) return "transparent";
        if (!raw?.x) return "#001DCB";
        return getNpsColor(raw.y);
      },
      backgroundColor: (ctx) => {
        const raw = ctx.raw;
        if (!raw) return "transparent";
        if (!raw?.x) return "#001DCB";
        return getNpsColor(raw.y);
      },
      minBarLength: 2,
    },
  ],
};

export const isNullInformation = (data, type) => {
  if (type === NPS_SCORE) {
    return !data?.totalChecked;
  }

  return !data.total;
};

export const printTotal = (data, type) => {
  if (type === NPS_SCORE) {
    return `NPS: ${data.total}, Promotores: ${data.promoters}, Pasivos: ${data.passives}, Detractores: ${data.detractors}`;
  }

  return `Total: ${data.total}`;
};
